/* eslint-disable */
// @ts-nocheck
import React, { useState, useContext, useRef, useEffect } from 'react';
import * as htmlToImage from 'html-to-image';
import {
    companionList, buildList, mainstatList, substatList, levelList, stellactrumList, memoryList, baseStatList,
    rankBonus
} from './constants';
import { defaultTeams, InputCoreCard } from './InputCoreCard.tsx';
import ChangeLog from './ChangeLog.tsx';
import './Rater.css';
import './Viewer.css';

const Viewer = () => {
    const coreListContext = useContext(InputCoreCard);
    if (!coreListContext) {
        throw new Error("useContext must be used inside a CoreCardProvider");
    }
    const { coreList, setCoreList } = coreListContext;
    const tagCContext = useContext(InputCoreCard);
    if (!tagCContext) {
        throw new Error("useContext must be used inside a CoreCardProvider");
    }
    const { tagCIndex, setTagCIndex } = tagCContext;
    const tagBContext = useContext(InputCoreCard);
    if (!tagBContext) {
        throw new Error("useContext must be used inside a CoreCardProvider");
    }
    const { tagBIndex, setTagBIndex } = tagBContext;
    const teamContext = useContext(InputCoreCard);
    if (!teamContext) {
        throw new Error("useContext must be used inside a CoreCardProvider");
    }
    const { team, setTeam } = teamContext;
    const memoryListFormatted = memoryList.map(item => ({
        name: item[0],
        scaling: item[1],
        star: item[2],
        character: item[3],
        stellactrum: item[4],
        type: item[5],
        pair: item[6],
        filename: item[7]
    }));
    const [searchTerm, setSearchTerm] = useState("");
    const [latestChanged, setLatestChanged] = useState("");
    const [latestCard, setLatestCard] = useState("");
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [showCoreSelector, setShowCoreSelector] = useState(false);
    const [coreSelectorData, setCoreSelectorData] = useState({});
    const [newStat, setNewStat] = useState({ hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 0, dbw: 0, eeb: 0, orb: 0, os: 0 });
    const [newStatCore, setNewStatCore] = useState(-1);
    const [oldStatCore, setOldStatCore] = useState(-1);
    const [showTeam, setShowTeam] = useState(false);
    const [openLog, setOpenLog] = useState(false);
    const [isCapturing, setIsCapturing] = useState(false);
    const dropdownRefs = useRef({});
    const buttonRefs = useRef({});
    const captureRef = useRef();
    const slotMapping = {
        "Solar 1": "solar1",
        "Solar 2": "solar2",
        "Lunar 1": "lunar1",
        "Lunar 2": "lunar2",
        "Lunar 3": "lunar3",
        "Lunar 4": "lunar4",
    };
    const substatMapping = {
        "Substat 1" : "substat1",
        "Substat 2" : "substat2",
        "Substat 3" : "substat3",
        "Substat 4" : "substat4"
    };

    const toggleDropdown = (dropdownId) => {
        setOpenDropdowns((prevState) => {
            const newState = { ...prevState, [dropdownId]: !prevState[dropdownId] };
            return newState;
        });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
          setOpenDropdowns((prevState) => {
            const newState = { ...prevState };
            Object.keys(newState).forEach((id) => {
              const buttonRef = buttonRefs.current[id];
              const dropdownRef = dropdownRefs.current[id];
              if (
                (!buttonRef || !buttonRef.contains(event.target)) &&
                (!dropdownRef || !dropdownRef.contains(event.target))
              ) {
                newState[id] = false;
              }
            });
            return newState;
          });
        };
      
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectCompanion = (companion) => {
        const selectedCompanion = companionList.find(
            (option) => option.companion === companion
        );
        if (selectedCompanion) {
            const file = selectedCompanion.filename !== "" ? `/images/${selectedCompanion.filename}` : "";
            if (team.character !== "" && selectedCompanion.companion === "Standard") {
                setTeam({...team, companion: selectedCompanion, filename: file})
            }
            else {
                setTeam({...team, companion: selectedCompanion, character: selectedCompanion.character, filename: file})
            }
        }
        setOpenDropdowns((prevState) => ({
            ...prevState,
            ["companionDD"]: false,
        }));
    }

    const setAffinity = (affinity) => {
        const value = affinity === "" ? "" : Number(affinity);
        setTeam({ ...team, affinity: value });
    }

    const setMemory = (name, slot, refName) => {
        const memoryInfo = memoryListFormatted.find(
            (option) => option.name === name
        );
        if (memoryInfo) {
            const file = memoryInfo.filename !== "" ? `/images/${memoryInfo.filename}` : "";
            const allSlotsEmpty = Object.values(slotMapping).every(slotKey => !team[slotKey]?.memory);
            if (allSlotsEmpty) {
                setTeam({ ...team, character: memoryInfo.character, [slotMapping[slot]]: { ...team[slotMapping[slot]], memory: name, filename: file } });
            }
            else {
                setTeam({ ...team, [slotMapping[slot]]: { ...team[slotMapping[slot]], memory: name, filename: file } });
            }
        }
        setLatestChanged(slotMapping[slot]);
        setOpenDropdowns((prevState) => ({
            ...prevState,
            [refName]: false,
        }));
        setSearchTerm("");
    };

    const setLevel = (level, slot) => {
        const value = level === "" ? "" : Number(level);
        setTeam({ ...team, [slotMapping[slot]]: { ...team[slotMapping[slot]], level: value, ascended: false } });
        setLatestChanged(slotMapping[slot]);
    };

    const setRank = (rank, slot) => {
        const value = rank === "" ? "" : Number(rank);
        setTeam({ ...team, [slotMapping[slot]]: { ...team[slotMapping[slot]], rank: value } });
        setLatestChanged(slotMapping[slot]);
    };

    const setIsAscended = (slot) => {
        setTeam(prevTeam => ({
            ...prevTeam,
            [slotMapping[slot]]: {
                ...prevTeam[slotMapping[slot]],
                ascended: !prevTeam[slotMapping[slot]].ascended
            }
        }));
        setLatestChanged(slotMapping[slot]);
    };

    const openProtocoreSelection = (memory, displayText, type, piece) => {
        const pieceName = type === "solar" && piece === 1 ? "Alpha" :
            type === "solar" && piece === 2 ? "Beta" :
            type === "lunar" && piece === 1 ? "Gamma" :
            type === "lunar" && piece === 2 ? "Delta" : "";
        const prevCore = coreList.findIndex(obj => obj.core.equip === memory.memory && obj.core.type === pieceName);
        setCoreSelectorData({
            memory: memory,
            displayText: displayText,
            type: type,
            piece: pieceName
        });
        setNewStatCore(prevCore);
        setOldStatCore(prevCore);
        setShowCoreSelector(true);
    }

    const closeProtocoreSelection = () => {
        setNewStat({ hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 0, dbw: 0, eeb: 0, orb: 0, os: 0 });
        setNewStatCore(-1);
        setOldStatCore(-1);
        setCoreSelectorData({});
        setShowCoreSelector(false);
    }

    const memoryDropdown = (memory, refName, displayText, type) => {
        return (
            <div className="memory-form">
                <div className="image-container">
                        {team[slotMapping[displayText]].memory ? team[slotMapping[displayText]].filename !== "" ?
                            <img className="image" src={team[slotMapping[displayText]].filename} alt={team[slotMapping[displayText]].memory} />
                            : <div className="no-image">No Image Available</div>
                            : <div className="no-image"></div>
                        }
                </div>
                <div className="memory-selection-form">
                    <div className="form-row">
                        <button ref={(el) => (buttonRefs.current[refName] = el)} className={`form-select select-width-100 dropdown white-bg-color`}
                        onClick={() => toggleDropdown(refName)}>
                            <p className="dropdown-text">{memory.memory || displayText}</p>
                            {openDropdowns[refName] ? <p className="dropdown-arrow">&#9652;</p> : <p className="dropdown-arrow">&#9662;</p>}
                        </button>
                        {openDropdowns[refName] && (
                            <div ref={(el) => (dropdownRefs.current[refName] = el)} className="dropdown-list-center select-width-100">
                                <div className="dropdown-item search-dropdown default-bg-color-hover">
                                    <input 
                                        className="search-memory"
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                { memoryListFormatted
                                    .filter(option => {
                                        const isCharacterMatch = team.character && team.character !== "default" ? option.character === team.character : true;
                                        const isCompanionMatch = team.companion && team.companion.companion !== "Standard" ? option.character === team.companion.character : true;
                                        const isTypeMatch = option.type === type;
                                        const otherSlots = Object.values(slotMapping).filter(slotKey => slotKey !== slotMapping[displayText]);
                                        const isAlreadySelected = otherSlots.some(slotKey => team[slotKey]?.memory === option.name);
                                        const matchesSearch = searchTerm ? option.name.toLowerCase().includes(searchTerm.toLowerCase()) : true;
                                        return isTypeMatch && isCharacterMatch && !isAlreadySelected && matchesSearch && isCompanionMatch;
                                    })
                                    .map((option, index) => (
                                    <div key={index} className="dropdown-item default-bg-color-hover stellactrum-option"
                                    onClick={() => setMemory(option.name, displayText, refName)}>
                                        <p className={`${option.stellactrum}-color circle-option`}>&#11044;</p>
                                        <p>{option.name}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="memory-specification">
                        <div className="memory-wrap">
                            <div className="form-row">
                                <div className="memory-input">
                                    <p className="memory-label">Level</p>
                                    <input 
                                        type="number" 
                                        className="form-select select-width-100 normal-select"
                                        value={memory.level}
                                        placeholder="Level"
                                        disabled={ memory.memory === "" }
                                        onChange={(e) => setLevel(e.target.value, displayText)}
                                    />
                                </div>
                                <div className="memory-ascension">
                                    <p className="memory-label">Ascended?</p>
                                    <div 
                                        className={`${team[slotMapping[displayText]].ascended ? team.character !== "" ? `${team.character}-bg-color` : "default-bg-color" : "white-bg-color"} ${(memory.memory === "" || team[slotMapping[displayText]].level % 10 !== 0) ? "disabled-form-2" : ""} checkbox ascension-check`} 
                                        onClick={() => setIsAscended(displayText)}>
                                    </div>
                                </div>
                            </div>
                            <p className="memory-label">Rank</p>
                            <div className="rank-button-row">
                                <button className={`rank-button ${team[slotMapping[displayText]].rank === 0 ? team.character !== "" ? `${team.character}-bg-color` : "default-bg-color" : "white-bg-color"} ${memory.memory === "" ? "disabled-form-2" : ""}`}
                                    onClick={() => setRank(0, displayText)}>0</button>
                                <button className={`rank-button ${team[slotMapping[displayText]].rank === 1 ? team.character !== "" ? `${team.character}-bg-color` : "default-bg-color" : "white-bg-color"} ${memory.memory === "" ? "disabled-form-2" : ""}`}
                                    onClick={() => setRank(1, displayText)}>1</button>
                                <button className={`rank-button ${team[slotMapping[displayText]].rank === 2 ? team.character !== "" ? `${team.character}-bg-color` : "default-bg-color" : "white-bg-color"} ${memory.memory === "" ? "disabled-form-2" : ""}`}
                                    onClick={() => setRank(2, displayText)}>2</button>
                                <button className={`rank-button ${team[slotMapping[displayText]].rank === 3 ? team.character !== "" ? `${team.character}-bg-color` : "default-bg-color" : "white-bg-color"} ${memory.memory === "" ? "disabled-form-2" : ""}`}
                                    onClick={() => setRank(3, displayText)}>3</button>
                            </div>
                        </div>
                        <div className="memory-wrap core-edit-wrap">
                            <p className="memory-label">Protocores</p>
                            <div className="core-edit-buttons">
                                <button className={`edit-button ${memory.memory === "" ? "disabled-form-2" : ""} white-bg-color`} 
                                    onClick={() => openProtocoreSelection(memory, displayText, type, 1)}>
                                        {`${type === "solar" ? "α" : "γ"} - ${coreList.findIndex(obj => obj.core.equip === memory.memory && (obj.core.type === "Alpha" || obj.core.type === "Gamma")) !== -1 ? "Equipped" : "Click to equip"}`}
                                    </button>
                                <button className={`edit-button ${memory.memory === "" ? "disabled-form-2" : ""} white-bg-color`} 
                                    onClick={() => openProtocoreSelection(memory, displayText, type, 2)}>{`${type === "solar" ? "β" : "δ"} - ${coreList.findIndex(obj => obj.core.equip === memory.memory && (obj.core.type === "Beta" || obj.core.type === "Delta")) !== -1 ? "Equipped" : "Click to equip"}`}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const addCardWithCores = (slot, newSlot, oldSlot) => {
        const coreSlot = newStatCore !== -1 ? (coreSelectorData.piece === "Alpha" || coreSelectorData.piece === "Gamma" ? "core1"
            : coreSelectorData.piece === "Beta" || coreSelectorData.piece === "Delta" ? "core2" : "") : "";
        let total = { hp: team[slot].hp, atk: team[slot].atk, def: team[slot].def, critrate: team[slot].critrate, critdmg: team[slot].critdmg,
            dbw: team[slot].dbw, eeb: team[slot].eeb, orb: team[slot].orb, os: team[slot].os };
        if (newSlot !== "" && slot === newSlot && newSlot !== oldSlot &&  coreSlot === "core1") {
            Object.keys(total).forEach(key => {
                total[key] += newStat[key] + team[slot].core2[key];
            });
        }
        else if (newSlot !== "" && slot === newSlot && newSlot !== oldSlot && coreSlot === "core2") {
            Object.keys(total).forEach(key => {
                total[key] += team[slot].core1[key] + newStat[key];
            });
        }
        else if (newSlot !== "" && slot === oldSlot && newSlot !== oldSlot && coreSlot === "core1") {
            Object.keys(total).forEach(key => {
                total[key] += team[slot].core2[key];
            });
        }
        else if (newSlot !== "" && slot === oldSlot && newSlot !== oldSlot && coreSlot === "core2") {
            Object.keys(total).forEach(key => {
                total[key] += team[slot].core1[key];
            });
        }
        else {
            Object.keys(total).forEach(key => {
                total[key] += team[slot].core1[key] + team[slot].core2[key];
            });
        }
        return total;
    }

    const calculateTalentDBW = (newSlot) => {
        const coreSlot = newStatCore !== -1 ? (coreSelectorData.piece === "Alpha" || coreSelectorData.piece === "Gamma" ? "core1"
            : coreSelectorData.piece === "Beta" || coreSelectorData.piece === "Delta" ? "core2" : "") : "";
        const oldSlot = Object.keys(team).find(key => {
            const value = team[key];
            return typeof value === "object" && value.memory === coreSelectorData.memory && value.memory !== "";
        }) || "";
        let cardDBW = 0;
        Object.values(slotMapping).forEach(key => {
            const memoryInfo = memoryListFormatted.find(
                (option) => option.name === team[key].memory
            );
            const baseTalent = memoryInfo?.scaling === "HP" ? baseStatList.baseHPTalent : memoryInfo?.scaling === "ATK" ? baseStatList.baseATKTalent : memoryInfo?.scaling === "DEF" ? baseStatList.baseDEFTalent : 0;
            const statTalent = memoryInfo?.scaling === "HP" ? "hp" : memoryInfo?.scaling === "ATK" ? "atk" : memoryInfo?.scaling === "DEF" ? "def" : "";
            let stat = 0;
            if (newSlot !== "" && key === newSlot && newSlot !== oldSlot &&  coreSlot === "core1") {
                stat = team[key][statTalent] + newStat[statTalent] + team[key].core2[statTalent];
            }
            else if (newSlot !== "" && key === newSlot && newSlot !== oldSlot && coreSlot === "core2") {
                stat = team[key][statTalent] + team[key].core1[statTalent] + newStat[statTalent];
            }
            else if (newSlot !== "" && key === oldSlot && newSlot !== oldSlot && coreSlot === "core1") {
                stat = team[key][statTalent] + team[key].core2[statTalent];
            }
            else if (newSlot !== "" && key === oldSlot && newSlot !== oldSlot && coreSlot === "core2") {
                stat = team[key][statTalent] + team[key].core1[statTalent];
            }
            else {
                stat = team[key][statTalent] + team[key].core1[statTalent] + team[key].core2[statTalent];
            }
            cardDBW += stat > baseTalent*20 ? (stat - baseTalent*20)/baseTalent*0.2 : 0;
        });
        return cardDBW;
    }

    const calculateComparison = (current, chosen, build, oath, solar1, solar2) => {
        const scaling = (team.companion.scaling).toLowerCase();
        const teamDmg = (solar1 !== undefined && solar2 !== undefined && solar1.pair === solar2.pair && solar1.pair !== "") ? 
            (team.solar1.rank >= 3 && team.solar2.rank >= 3 && solar1.star === "5") ? rankBonus.teamDmg5Star * 2 :
            (team.solar1.rank >= 3 && team.solar2.rank >= 3 && solar1.star === "4") ? rankBonus.teamDmg4Star * 2 :
            (solar1.star === "5") ? rankBonus.teamDmg5Star : rankBonus.teamDmg4Star : 0;
        let currentDamage = 0;
        let newDamage = 0;
        if (build === "dtw") {
            currentDamage = oath ? (current.atk / 3 + (2 * current[scaling]) / 3) * (1 + current.dbw / 100) * (1 + current.os / 100) * (1 + teamDmg / 100)
                : (current.atk / 3 + (2 * current[scaling]) / 3) * (1 + current.dbw / 100) * (1 + teamDmg / 100);
            newDamage = oath ? (chosen.atk / 3 + (2 * chosen[scaling]) / 3) * (1 + chosen.dbw / 100) * (1 + chosen.os / 100) * (1 + teamDmg / 100)
                : (chosen.atk / 3 + (2 * chosen[scaling]) / 3) * (1 + chosen.dbw / 100) * (1 + teamDmg / 100);
        }
        if (build === "crit") {
            currentDamage = oath ? (current.atk / 3 + (2 * current[scaling]) / 3) * (1 + teamDmg / 100) * (1 + current.os / 100)
                : (current.atk / 3 + (2 * current[scaling]) / 3) * (1 + teamDmg / 100) * (1 + Math.min(current.critrate / 100, 1) * (current.critdmg / 100));
            newDamage = oath ? (team.companion.companion === "Ultimate Weapon X-02" ? (chosen.atk / 3 + (2 * chosen[scaling]) / 3) * (1 + teamDmg / 100) * (1 + chosen.os / 100) * (1 + Math.min(chosen.critrate / 100, 1) * (chosen.critdmg / 100))
                : (chosen.atk / 3 + (2 * chosen[scaling]) / 3) * (1 + teamDmg / 100) * (1 + chosen.os / 100))
                : (chosen.atk / 3 + (2 * chosen[scaling]) / 3) * (1 + teamDmg / 100) * (1 + Math.min(chosen.critrate / 100, 1) * (chosen.critdmg / 100));
        }
        const difference = (newDamage - currentDamage) / currentDamage * 100;
        return (
            <span className={`comparison-value ${difference > 0 ? "pos-color" : difference < 0 ? "neg-color" : ""}`}>{`${(difference).toFixed(2)}%`}</span>
        );
    }

    const getPairAndDualRank = () => {
        const solar1Info = memoryListFormatted.find(
            (option) => option.name === team.solar1.memory
        );
        const solar2Info = memoryListFormatted.find(
            (option) => option.name === team.solar2.memory
        );
        if (solar1Info !== undefined && solar2Info !== undefined && solar1Info.pair === solar2Info.pair && solar1Info !== "") {
            const dualRank = team.solar1.rank === 3 && team.solar2.rank === 3 ? "IV"
                : team.solar1.rank >= 2 && team.solar2.rank >= 2 ? "III"
                : team.solar1.rank >= 1 && team.solar2.rank >= 1 ? "II" : "I";
            return [solar1Info.pair, dualRank];
        }
        else {
            return ["", ""];
        }
    }

    const displayStat = (isDisplayCard: boolean, stat?: { [key: string]: number }, slot?: string) => {
        const solar1Info = memoryListFormatted.find(
            (option) => option.name === team.solar1.memory
        );
        const solar2Info = memoryListFormatted.find(
            (option) => option.name === team.solar2.memory
        );
        const [cardPair, dualRank] = getPairAndDualRank() as [string, string];
        let current = { hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 150, dbw: 0, eeb: 0, orb: 0, os: 0 };
        let chosen = { hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 150, dbw: 0, eeb: 0, orb: 0, os: 0 };
        const hasStat = stat && slot;
        Object.values(slotMapping).forEach(key => {
            const keyStat = addCardWithCores(key, "", "");
            Object.keys(current).forEach(key =>{
                current[key] += keyStat[key];
            })
        });
        if (hasStat) {
            const oldSlot = Object.keys(team).find(key => {
                const value = team[key];
                return typeof value === "object" && value.memory === coreList[newStatCore].core.equip && value.memory !== "";
            }) || "";
            Object.values(slotMapping).forEach(key => {
                const keyStat = addCardWithCores(key, slot, oldSlot);
                Object.keys(chosen).forEach(key =>{
                    chosen[key] += keyStat[key];
                })
            });
        }
        current.dbw += calculateTalentDBW("");
        chosen.dbw += calculateTalentDBW(slot);
        const affinityBonus = Math.floor(team.affinity / 5);
        current.hp += affinityBonus * 200;
        chosen.hp += affinityBonus * 200;
        current.atk += affinityBonus * 10;
        chosen.atk += affinityBonus * 10;
        current.def += affinityBonus * 5;
        chosen.def += affinityBonus * 5;
        if (cardPair !== "" && dualRank !== "I") {
            current.orb = solar1Info.star === "5" ? current.orb + rankBonus.orb5Star : current.orb + rankBonus.orb4Star;
            chosen.orb = solar1Info.star === "5" ? chosen.orb + rankBonus.orb5Star : chosen.orb + rankBonus.orb4Star;
        }
        const statMap = {
            "HP" : "hp",
            "ATK" : "atk",
            "DEF" : "def",
            "Crit Rate" : "critrate",
            "Crit DMG" : "critdmg",
            "Oath's Strength" : "os",
            "Oath Recovery Boost" : "orb",
            "Expedited Energy Boost" : "eeb",
            "Damage Boost to Weakened" : "dbw"
        }
        return(
            <div className="stat-display">
                <div>
                    <p className="memory-label label-font">Team Attributes</p>
                    <div className="stat-display-table">
                        { Object.entries(statMap).map(([key, value], index) => (
                            <div key={key} className={`stat-display-row ${index % 4 === 0 || index % 4 === 1 ? (isDisplayCard ? "stat-row-background" : "stat-row-background-var") : ""} `}>
                                { index % 2 === 1 &&
                                    <span>|</span>
                                }
                                <span className={`stat-row-key ${isDisplayCard ? "" : "stat-row-text-var"} ${value === "os" || value ==="eeb" || value === "dbw" || value === "orb" ? "stat-row-small-font": ""}`}>{key}</span>
                                <span className={`stat-row-value ${isDisplayCard ? "" : "stat-row-text-var"}`}>{value !== "hp" && value !== "atk" && value !== "def" ? `${(current[value]).toFixed(1)}%` : (current[value]).toFixed(0)}</span>
                                { stat &&
                                    <span className={`stat-row-value ${chosen[value] > current[value] ? "pos-color" : chosen[value] < current[value] ? "neg-color" : (isDisplayCard ? "" : "stat-row-text-var")}`}>
                                        {`\u2192 ${value !== "hp" && value !== "atk" && value !== "def" ? `${(chosen[value]).toFixed(1)}%` : (chosen[value]).toFixed(0)}`}
                                    </span>
                                }
                            </div>
                        ))}
                        <div className={`stat-display-row ${isDisplayCard ? "stat-row-background" : "stat-row-background-var"}`}></div>
                    </div>
                </div>
                { hasStat && team.companion !== "" &&
                    <div className="comparison-container">
                        <p className="memory-label label-font">Damage Comparisons & Resource Recovery Rates</p>
                        <div className="comparison-section">
                            <div className="comparison-row comparison-bg">
                                <span className="comparison-text">Against weakened enemy: </span>
                                {calculateComparison(current, chosen, "dtw", false, solar1Info, solar2Info)}
                            </div>
                            <div className="comparison-row">
                                <span className="comparison-text">Against weakened enemy (Oath): </span>
                                {calculateComparison(current, chosen, "dtw", true, solar1Info, solar2Info)}
                            </div>
                            <div className="comparison-row comparison-bg">
                                <span className="comparison-text">Against shielded enemy: </span>
                                {calculateComparison(current, chosen, "crit", false, solar1Info, solar2Info)}
                            </div>
                            <div className="comparison-row">
                                <span className="comparison-text">Against shielded enemy (Oath): </span>
                                {calculateComparison(current, chosen, "crit", true, solar1Info, solar2Info)}
                            </div>
                            <div className="comparison-row comparison-bg">
                                <span className="comparison-text">Seconds to recharge Oath: </span>
                                <span className="comparison-value">{`${(67 / (1 + current.orb / 100)).toFixed(1)}s \u2192 ${(67 / (1 + chosen.orb / 100)).toFixed(1)}s`}</span>
                            </div>
                            <div className="comparison-row">
                                <span className="comparison-text">Seconds to recharge 1 Energy: </span>
                                <span className="comparison-value">{`${(8 / (1 + current.eeb / 100)).toFixed(1)}s \u2192 ${(8 / (1 + chosen.eeb / 100)).toFixed(1)}s`}</span>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }

    const displayProtocore = (item, styling, isDetailed, index, companion, buildIndex) => {
        const cIndex = !isDetailed ? -1 : (item.companion.findIndex(list => list.companion === companion) !== -1) ? item.companion.findIndex(list => list.companion === companion) : -1;
        const bIndex = !isDetailed ? buildIndex : (tagBIndex[index] === -1) ? item.sortedTotalRV[0].bIndex : tagBIndex[index];
        const changeCIndex = (newCIndex) => {
            setTagCIndex((prev) => {
                const updatedIndexes = [...prev];
                updatedIndexes[index] = newCIndex;
                return updatedIndexes;
            });
        };
        const changeBIndex = (newBIndex) => {
            setTagBIndex((prev) => {
                const updatedIndexes = [...prev];
                updatedIndexes[index] = newBIndex;
                return updatedIndexes;
            });
        };
        const scalingBonus = `${team.companion.scaling} Bonus`;
        return (
            <div className={`${styling} display-core`}>
                <div className="core-info">
                    <div className="core-header">
                        <div className="core-type">
                            <p className={`${item.core.stellactrum}-color stellactrum-circle`}>&#11044;</p>
                            <p className="type-name">{item.core.stellactrum} Protocore {item.core.type === "Alpha" ? "- α" : item.core.type === "Beta" ? "- β" : item.core.type === "Gamma" ? "- γ" : item.core.type === "Delta" ? "- δ" : ""}</p>
                        </div>
                        <div className="level-div">
                            <p className="core-level">+{item.core.level}</p>
                        </div>
                    </div>
                    { isDetailed && cIndex !== -1 &&
                        <div className="core-tags">
                            { item.companion.filter((_, index) => index === cIndex).map((option, c) => (
                                <div key={c}>
                                    <p className={`${option.character}-bg-color ${option.character}-color tag-style`} onClick={() => changeCIndex(c)}>{cIndex === c ? "\u2713 " : ""}{option.companion}</p>
                                </div>
                            ))}
                            { item.build.map((option, b) => (
                                <div key={b}>
                                    <p className="tag-style" onClick={() => changeBIndex(b)}>{bIndex === b ? "\u2713 " : ""}{option}</p>
                                </div>
                            ))}
                        </div>
                    }
                    <div className="core-mainstat">
                        <p className="stat-attribute">{item.core.mainstat}</p>
                        <p className="stat-value"> 
                            +{(() => {
                                const mainstat = mainstatList.find((option) => option.attribute === item.core.mainstat);
                                return mainstat ? parseFloat(((mainstat.increment * item.core.level) + mainstat.initial).toFixed(1)) : "";
                            })()}
                            {item.core.mainstat === "HP" || item.core.mainstat === "ATK" ? "" : "%"}
                        </p>
                    </div>
                    <div className={`core-substat ${item.core.substat1.attribute === scalingBonus ? "scaling-substat" : cIndex !== -1 && item.core.substat1.attribute !== scalingBonus && item.core.substat1.ssRating[cIndex][bIndex] === "S" ? "good-substat" : ""}`}>
                        <p className="stat-attribute">{item.core.substat1.attribute}</p>
                        <p className="stat-value">
                            +{item.core.substat1.value}
                            {item.core.substat1.attribute === "HP" || item.core.substat1.attribute === "ATK" || item.core.substat1.attribute === "DEF" ? "" : "%"}
                        </p>
                    </div>
                    <div className={`core-substat ${item.core.substat2.attribute === scalingBonus ? "scaling-substat" : cIndex !== -1 && item.core.substat2.attribute !== scalingBonus && item.core.substat2.ssRating[cIndex][bIndex] === "S" ? "good-substat" : ""}`}>
                        <p className="stat-attribute">{item.core.substat2.attribute}</p>
                        <p className="stat-value">
                            +{item.core.substat2.value}
                            {item.core.substat2.attribute === "HP" || item.core.substat2.attribute === "ATK" || item.core.substat2.attribute === "DEF" ? "" : "%"}
                        </p>
                    </div>
                    {
                        item.core.substat3.attribute !== "None" &&
                        <div className={`core-substat ${item.core.substat3.attribute === scalingBonus ? "scaling-substat" : cIndex !== -1 && item.core.substat3.attribute !== scalingBonus && item.core.substat3.ssRating[cIndex][bIndex] === "S" ? "good-substat" : ""}`}>
                            <p className="stat-attribute">{item.core.substat3.attribute}</p>
                            <p className="stat-value">
                                +{item.core.substat3.value}
                                {item.core.substat3.attribute === "HP" || item.core.substat3.attribute === "ATK" || item.core.substat3.attribute === "DEF" ? "" : "%"}
                            </p>
                        </div>
                    }
                    {
                        item.core.substat4.attribute !== "None" &&
                        <div className={`core-substat ${item.core.substat4.attribute === scalingBonus ? "scaling-substat" : cIndex !== -1 && item.core.substat4.attribute !== scalingBonus && item.core.substat4.ssRating[cIndex][bIndex] === "S" ? "good-substat" : ""}`}>
                            <p className="stat-attribute">{item.core.substat4.attribute}</p>
                            <p className="stat-value">
                                +{item.core.substat4.value}
                                {item.core.substat4.attribute === "HP" || item.core.substat4.attribute === "ATK" || item.core.substat4.attribute === "DEF" ? "" : "%"}
                            </p>
                        </div>
                    }
                </div>
                { isDetailed && cIndex !== -1 &&
                    <div>
                        <div className="core-display-rating">
                            <p className={`${item.core.msRating[cIndex][bIndex] === "S" || item.core.msRating[cIndex][bIndex] === "A" ? "good-ms-bg-color" : "bad-ms-bg-color"} core-rating`}>Main stat: {item.core.msRating[cIndex][bIndex] === "S" ? "Good" : item.core.msRating[cIndex][bIndex] === "A" ? "--" : "Bad"}</p>
                            <p className={`${item.core.rvRating[cIndex][bIndex]}-core-bg-border core-rating`}>Substat: {item.core.totalRV[cIndex][bIndex]}%</p>
                        </div>
                    </div>
                }
            </div>
        );
    }

    const equipProtocore = (index, slot, withNewStat, piece) => {
        const core1Index = withNewStat ? index : coreList.findIndex(obj => obj.core.equip === team[slot].memory && (obj.core.type === "Alpha" || obj.core.type === "Gamma"));
        const core2Index = withNewStat ? -1 : coreList.findIndex(obj => obj.core.equip === team[slot].memory && (obj.core.type === "Beta" || obj.core.type === "Delta"));
        let equipped0 = { hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 0, dbw: 0, eeb: 0, orb: 0, os: 0 };
        let equipped1 = { hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 0, dbw: 0, eeb: 0, orb: 0, os: 0 };
        const map = {equipped0, equipped1};
        const coreIndexList = [core1Index, core2Index];
        for (let i = 0; i < 2; i++) {
            if (coreIndexList[i] === -1) continue;
            const core = coreList[coreIndexList[i]].core;
            const mainstat = mainstatList.find(
                (option) => option.attribute === core.mainstat
            );
            Object.keys(team[slot]).forEach(key => {
                if (key === mainstat?.map) {
                    const totalStat = (mainstat.increment * core.level) + mainstat.initial;
                    if (mainstat.attribute.includes('Bonus')) {
                        map[`equipped${i}`][key] += team[slot][key] * (totalStat / 100);
                    } else {
                        map[`equipped${i}`][key] += totalStat;
                    }
                }
            });
            Object.values(substatMapping).forEach(sub => {
                const substat = substatList.find(
                    (option) => option.attribute === core[sub].attribute
                );
                Object.keys(team[slot]).forEach(key => {
                    if (key === substat?.map) {
                        const totalStat = core[sub].value;
                        if (substat.attribute.includes('Bonus')) {
                            map[`equipped${i}`][key] += team[slot][key] * (totalStat / 100);
                        } else {
                            map[`equipped${i}`][key] += totalStat;
                        }
                    }
                });
            });
        }
        if (withNewStat) {
            setNewStat({...newStat, hp: equipped0.hp, atk: equipped0.atk, def: equipped0.def, 
                critrate: equipped0.critrate, critdmg: equipped0.critdmg, dbw: equipped0.dbw, 
                eeb: equipped0.eeb, orb: equipped0.orb, os: equipped0.os });
            setNewStatCore(index);
        }
        else {
            setTeam({...team, [slot]: { ...team[slot], 
                core1: equipped0, core2: equipped1
            }});
        }
    }

    const applyNewStat = (slot) => {
        if (newStatCore !== -1) {
            const coreSlot = coreSelectorData.piece === "Alpha" || coreSelectorData.piece === "Gamma" ? "core1"
                : coreSelectorData.piece === "Beta" || coreSelectorData.piece === "Delta" ? "core2" : "";
            const oldSlot = Object.keys(team).find(key => {
                const value = team[key];
                return typeof value === "object" && value.memory === coreList[newStatCore].core.equip && value.memory !== "";
            }) || "";
            const updatedCoreList = coreList.map((entry, index) => 
                index === newStatCore && newStatCore !== oldStatCore ? 
                {...entry, core: {...entry.core, equip: team[slot].memory}} :
                index === oldStatCore ?
                {...entry, core: {...entry.core, equip: ""}} :
                entry
            );
            setCoreList(updatedCoreList);
            if (newStatCore !== oldStatCore) {
                setTeam({...team, [slot]: { ...team[slot], [coreSlot]: newStat}, [oldSlot]: { ...team[oldSlot], [coreSlot]: { hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 0, dbw: 0, eeb: 0, orb: 0, os: 0 } }});
            }
            else {
                setTeam({...team, [oldSlot]: { ...team[oldSlot], [coreSlot]: { hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 0, dbw: 0, eeb: 0, orb: 0, os: 0 } }});
            }
            setNewStat({ hp: 0, atk: 0, def: 0, critrate: 0, critdmg: 0, dbw: 0, eeb: 0, orb: 0, os: 0 });
            setNewStatCore(-1);
            setOldStatCore(-1);
            setCoreSelectorData({});
            setShowCoreSelector(false);
        }
    }

    const displaySelectorModal = () => {
        const piece = coreSelectorData.piece;
        const memoryInfo = memoryListFormatted.find(
            (option) => option.name === coreSelectorData.memory.memory
        );
        const filteredCoreList = coreList
            .map((item, index) => ({ item, originalIndex: index }))
            .filter(({ item }) => item.core.type === piece && item.core.stellactrum === memoryInfo?.stellactrum);
        return(
            <div className="core-selector-modal">
                <p className="form-section-label">{coreSelectorData.displayText} - {piece} Protocore</p>
                <div className="protocore-selector">
                    <div className="protocore-selector-list">
                        {filteredCoreList.map(({item, originalIndex}, index) => (
                            <>
                                {(newStatCore === originalIndex) && 
                                    <p className={`selected-core-label ${team.character ? `${team.character}-dark-bg-color` : "default-dark-bg-color"}`}>SELECTED</p>
                                }
                                <button key={originalIndex} className={`${newStatCore === originalIndex ? "selected-core-in-modal" : ""} core-select-button ${team.character ? `${team.character}-bg-color` : "default-bg-color"}`} 
                                    onClick={() => equipProtocore(originalIndex, slotMapping[coreSelectorData.displayText], true, piece)}>
                                    {coreList[originalIndex].core.equip && 
                                        <p className="equipped-core-label">{`Equipped by: ${coreList[originalIndex].core.equip}`}</p>
                                    }
                                    {displayProtocore(item, "each-core-display", true, originalIndex, team.companion.companion, -1)}
                                </button>
                            </>
                        ))}
                    </div>
                    <div className="stat-change-viewer">
                        <div>
                            {newStatCore !== -1 && Object.values(newStat).some(value => value !== 0) ? displayStat(false, newStat, slotMapping[coreSelectorData.displayText]) : displayStat(false)}
                        </div>
                    </div>
                </div>
                <div className="equip-cancel-menu">
                    { (newStatCore === -1 && Object.values(newStat).every(value => value === 0)) || newStatCore === oldStatCore &&
                        <button className={`menu-button ${team.character !== "" ? `${team.character}-bg-color` : "default-bg-color"}`} onClick={() => applyNewStat(slotMapping[coreSelectorData.displayText])}>Unequip</button>
                    }
                    { (newStatCore ==! -1 && Object.values(newStat).every(value => value !== 0)) || newStatCore !== oldStatCore &&
                        <button className={`menu-button ${team.character !== "" ? `${team.character}-bg-color` : "default-bg-color"}`} onClick={() => applyNewStat(slotMapping[coreSelectorData.displayText])}>Equip</button>
                    }
                    <button className="menu-button white-bg-color" onClick={() => closeProtocoreSelection()}>Cancel</button>
                </div>
            </div>
        );
        
    }

    const getBaseAndInc = (slot, conv, unit, isTalent) => {
        const r0Base = isTalent ? unit * conv * baseStatList.baseSpMtp : unit * conv * baseStatList.baseMtp;
        const r0Inc = r0Base / baseStatList.baseMtp;
        const rank = team[slot].rank !== 0 ? r0Inc * 2.4 * team[slot].rank : 0;
        const base = r0Base + rank;
        const inc = base / baseStatList.baseMtp;
        return [base, inc];
    }

    const calculateStat = (slot) => {
        const memoryInfo = memoryListFormatted.find(
            (option) => option.name === team[slot].memory
        );
        const conv = memoryInfo?.star === "5" ? 1 : memoryInfo?.star === "4" ? baseStatList.conv4Star : baseStatList.conv3Star;
        const ascension = team[slot].ascended && team[slot].level % 10 === 0 && team[slot].level !== 80 ? team[slot].level / 10 
            : team[slot].ascended && team[slot].level % 10 === 0 && team[slot].level === 80 ? team[slot].level / 10 - 1 
            : !team[slot].ascended && team[slot].level % 10 === 0 ? team[slot].level / 10 - 1
            : !team[slot].ascended && team[slot].level % 10 !== 0 ? Math.floor(team[slot].level / 10) : 0;
        const awakened = team[slot].ascended && team[slot].level === 80 ? 1 : 0;
        const [baseHP, incHP] = getBaseAndInc(slot, conv, baseStatList.baseHP, memoryInfo?.scaling === "HP" ? true : false)  as [number, number];
        const cardHP = Math.floor(baseHP + incHP * (team[slot].level - 1) + incHP * baseStatList.ascensionMtp * ascension + baseHP / 2 * awakened);
        const [baseATK, incATK] = getBaseAndInc(slot, conv, baseStatList.baseATK, memoryInfo?.scaling === "ATK" ? true : false)  as [number, number];
        const cardATK = Math.floor(baseATK + incATK * (team[slot].level - 1) + incATK * baseStatList.ascensionMtp * ascension + baseATK / 2 * awakened);
        const [baseDEF, incDEF] = getBaseAndInc(slot, conv, baseStatList.baseDEF, memoryInfo?.scaling === "DEF" ? true : false)  as [number, number];
        const cardDEF = Math.floor(baseDEF + incDEF * (team[slot].level - 1) + incDEF * baseStatList.ascensionMtp * ascension + baseDEF / 2 * awakened);
        const baseCR = memoryInfo?.star === "5" ? baseStatList.baseCritRate5 : memoryInfo?.star === "4" ? baseStatList.baseCritRate4 : baseStatList.baseCritRate3;
        const incCR = memoryInfo?.star === "5" ? baseStatList.critMtp5 : baseStatList.critMtp4;
        const rankCR = memoryInfo?.star === "5" ? baseStatList.critRank5 : memoryInfo?.star === "4" ? baseStatList.critRank4 : baseStatList.critRank3;
        const awakenCR = memoryInfo?.star === "5" ? baseStatList.critAwake5 : memoryInfo?.star === "4" ? baseStatList.critAwake4 : 0;
        const cardCritRate = slot.includes("lunar") ? baseCR + incCR * ascension + rankCR * team[slot].rank + awakenCR * awakened : 0; 
        const cardCritDMG = slot.includes("solar") ? (baseCR + incCR * ascension + rankCR * team[slot].rank + awakenCR * awakened) * 2 : 0;
        
        setTeam({...team, [slot]: {...team[slot], hp: cardHP, atk: cardATK, def: cardDEF, critrate: cardCritRate, critdmg: cardCritDMG }});
        setLatestCard(slot);
    }

    const openTeamDisplay = () => {
        setShowTeam(!showTeam);
    }

    const handleTeamImageDownload = async () => {
        const teamName = team.companion.companion ? team.companion.companion.replaceAll(" ", "-") : team.character;
        try {
            setIsCapturing(true);
            const node = captureRef.current;
            await htmlToImage.toCanvas(node);
            const dataURL = await htmlToImage.toBlob(node, { pixelRatio: 3 });
            console.log("Image generated");
            const url = URL.createObjectURL(dataURL);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${teamName}-team.png`;
            link.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Failed to capture image:", error);
        } finally {
            setIsCapturing(false);
        }
    };

    const captureCoreStatDisplay = (memory, piece) => {
        const core = coreList.find(
            obj => obj.core.equip === memory && obj.core.type === piece
        );
        if (core !== undefined) {
            const mainstat = mainstatList.find(
                obj => obj.attribute === core.core.mainstat
            )
            return (
                <div className="capture-protocore-card">
                    <div className="capture-mainstat">
                        <div className="capture-stat-mainstat">
                            <p className={`capture-core-type ${core.core.stellactrum}-color ${core.core.type === "Beta" || core.core.type === "Delta" ? "for-big-core-type-symbol" : ""}`}>
                                {`${core.core.type === "Alpha" ? "\u2666\uFE0E" : core.core.type === "Beta" ? "\u25A0\uFE0E" : core.core.type === "Gamma" ? "\u2738\uFE0E" : core.core.type === "Delta" ? "\u25BC\uFE0E" : ""}`}
                            </p>
                            <img className="capture-stat-symbol" src={`/images/${mainstat?.map}.PNG`} alt={`${mainstat?.map} icon`} />
                            <p className="capture-mainstat-text">{`${parseFloat(((mainstat.increment * core.core.level) + mainstat.initial).toFixed(1))}${mainstat?.attribute === "HP" || mainstat?.attribute === "ATK" || mainstat?.attribute === "DEF" ? "" : "%"}`}</p>
                        </div>
                        <div className="capture-core-level">
                            <p className="capture-core-level-text">{`+${core.core.level}`}</p>
                        </div>
                    </div>
                    {
                        Object.values(substatMapping).map(sub => {
                            const substat = substatList.find(
                                (option) => option.attribute === core.core[sub].attribute
                            );
                            const column = sub.includes('1') || sub.includes('2') ? 1 : 2;
                            const row = sub.includes('1') || sub.includes('3') ? 1 : 2;
                            if (substat?.attribute !== "None") {
                                return (
                                    <div className={`capture-stat stat-column-${column} stat-row-${row}`}>
                                        <img className="capture-stat-symbol" src={`/images/${substat?.map}.PNG`} alt={`${substat?.map} icon`} />
                                        <p className="capture-stat-text">{`${core.core[sub].value}${substat?.attribute === "HP" || substat?.attribute === "ATK" || substat?.attribute === "DEF" ? "" : "%"}`}</p>
                                    </div>
                                );
                            }
                        })
                    }
                </div>
            );
        }
    }

    const displayCaptureCard = (slot, position) => {
        if (slot !== "none") {
            const memoryInfo = memoryListFormatted.find(
                (option) => option.name === team[slot].memory
            );
            const cardTypeFile = slot.includes('solar') ? `/images/solar.PNG` : `/images/lunar.PNG`;
            const rankFile = `/images/rank${team[slot].rank}.PNG`
            const starFile = `/images/${memoryInfo?.star}stars.PNG`
            return (
                <div className={`capture-card margin-position-${position}`}>
                    { team[slot].filename !== "" ? 
                        <img className="capture-card-img" src={team[slot].filename} alt={team[slot].memory} /> :
                        <div className="capture-card-img fallback-img">
                            <p className="fallback-img-text">{team[slot].memory}</p>
                        </div>
                    }
                    <div className="capture-card-img-block"></div>
                    <p className={`capture-card-stellactrum ${memoryInfo.stellactrum}-color`}>&#11044;</p>
                    <img className={`capture-card-type-symbol capture-card-${slot.includes('solar') ? "solar" : "lunar"}-symbol`} src={cardTypeFile} alt={slot.includes('solar') ? "solar" : "lunar"} />
                    <p className="capture-card-level">{team[slot].level}</p>
                    <img className="capture-card-rank-symbol" src={rankFile} alt={team[slot].rank} />
                    <img className={`capture-card-star-symbol capture-card-${memoryInfo?.star}-star`} src={starFile} alt={`${memoryInfo?.star} stars`} />
                    { team[slot].level === 80 && team[slot].ascended === true && <div className="capture-card-ascended"></div> }
                    <div className="capture-protocores">
                        <div className="capture-core-1">
                            {captureCoreStatDisplay(team[slot].memory, slot.includes('solar') ? "Alpha" : "Gamma")}
                        </div>
                        <div className="capture-core-2">
                            {captureCoreStatDisplay(team[slot].memory, slot.includes('solar') ? "Beta" : "Delta")}
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div className={`capture-card margin-position-${position} capture-empty-card`}></div>
            );
        }
    }

    const clearTeam = () => {
        setTeam(defaultTeams);
        setShowTeam(false);
    }

    const handleOpenLog = () => {
        setOpenLog(!openLog);
    }

    useEffect(() => {
        if (latestChanged !== "") {
            calculateStat(latestChanged);
            setLatestChanged("");
        }
    }, [latestChanged]);

    useEffect(() => {
        if (latestCard !== "") {
            equipProtocore(-1, latestCard, false);
            setLatestCard("");
        }
    }, [latestCard]);

    return(
        <div>
            <div className="team-form">
                <div className="companion-viewer-form">
                    <div className="form-row">
                        <button ref={(el) => (buttonRefs.current["companionDD"] = el)} className="form-select select-width-100 dropdown white-bg-color"
                            onClick={() => toggleDropdown('companionDD')}>
                            <p className="dropdown-text">{team.companion.companion || "Companion"}</p>
                            {openDropdowns['companionDD'] ? <p className="dropdown-arrow">&#9652;</p> : <p className="dropdown-arrow">&#9662;</p>}
                        </button>
                        {openDropdowns['companionDD'] && (
                            <div ref={(el) => (dropdownRefs.current["companionDD"] = el)} className="dropdown-list-center select-width-100">
                                {companionList.filter(option => {
                                        const isMatchCharacter = team.character ? option.character === team.character : true;
                                        return isMatchCharacter || option.companion === "Standard"
                                    }).map((option, index) => (
                                    <div key={index} className="dropdown-item default-bg-color-hover"
                                    onClick={() => selectCompanion(option.companion)}>
                                        {option.companion}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="affinity-selection">
                        <p className="affinity-label">Affinity Level</p>
                        <input 
                            type="number" 
                            className="form-select select-width-100 affinity-value normal-select"
                            value={team.affinity}
                            placeholder="Affinity"
                            disabled={ team.character === "" }
                            onChange={(e) => setAffinity(e.target.value)}
                        />
                    </div>
                    { team.companion &&
                        <div className="companion-image-container">
                            {team.companion.companion !== "Standard" ? team.filename !== "" ? 
                                <img className="companion-image" src={team.filename} alt={team.companion.companion} />
                                : <div className="no-companion-image">No Image Available</div>
                                : <div></div>}
                        </div>
                    }
                    {displayStat(false)}
                </div>
                <div className="memory-viewer-form">
                    <p className="form-section-label">Solar Memories</p>
                    <div className="memory-row">
                        {memoryDropdown(team.solar1, "solar1DD", "Solar 1", "solar")}
                        {memoryDropdown(team.solar2, "solar2DD", "Solar 2", "solar")}
                    </div>
                    <p className="form-section-label">Lunar Memories</p>
                    <div className="memory-row">
                        {memoryDropdown(team.lunar1, "lunar1DD", "Lunar 1", "lunar")}
                        {memoryDropdown(team.lunar2, "lunar2DD", "Lunar 2", "lunar")}
                    </div>
                    <div className="memory-row">
                        {memoryDropdown(team.lunar3, "lunar3DD", "Lunar 3", "lunar")}
                        {memoryDropdown(team.lunar4, "lunar4DD", "Lunar 4", "lunar")}
                    </div>
                    <p className="form-section-label">Options</p>
                    <div className="viewer-options-menu">
                        { isCapturing && <div className="loader"></div> }
                        { showTeam && <button className={`menu-button ${team.character !== "" ? `${team.character}-bg-color` : "default-bg-color"} ${isCapturing ? "disabled-form" : ""}`} onClick={() => handleTeamImageDownload()}>&#8595; Download</button> }
                        <button className={`menu-button ${team.character !== "" ? `${team.character}-bg-color` : "default-bg-color disabled-form-2"}`} onClick={() => openTeamDisplay()}>{`${showTeam ? "Hide Team Image" : "Display Team Image"}`}</button>
                        <button className={`menu-button ${team.character !== "" ? `${team.character}-bg-color` : "default-bg-color"}`} onClick={() => clearTeam()}>&#215; Clear Team</button>
                    </div>
                    { showTeam && 
                        <div className="capture-container">
                            <div ref={captureRef} className={`capture-target`}>
                                <div className="capture-affinity">
                                    <p className="capture-affinity-symbol">&#9829;&#xFE0E;</p>
                                    <p className="capture-affinity-text">{team.affinity}</p>
                                </div>
                                { getPairAndDualRank()[1] !== "" &&
                                    <div className="capture-dual-rank">
                                        <p className="capture-dual-rank-text">{getPairAndDualRank()[1]}</p>
                                        <p className="capture-dual-rank-pair">{getPairAndDualRank()[0]}</p>
                                    </div>
                                }
                                <img className="capture-background-img" src={`/images/capture_background.png`} alt="capture-background" />
                                {team.companion.companion !== "Standard" && team.filename !== "" && <img className="capture-companion-img" src={team.filename} />}
                                <div className="capture-main-stat-div">{displayStat(true)}</div>
                                <div className="capture-solar">
                                    <div className="capture-label solar-label">
                                        <img className={`symbol-label-img symbol-label-solar-img`} src={`/images/solar.PNG`} alt="Solar label" />
                                        <p className={`symbol-label-text`}>Solar</p>
                                    </div>
                                    {team.solar1.memory !== "" ? displayCaptureCard('solar1', 1) : displayCaptureCard('none', 1)}
                                    {team.solar2.memory !== "" ? displayCaptureCard('solar2', 2) : displayCaptureCard('none', 2)}
                                </div>
                                <div className="capture-lunar">
                                    <div className="capture-label lunar-label">
                                        <img className={`symbol-label-img symbol-label-lunar-img`} src={`/images/lunar.PNG`} alt="Lunar label" />
                                        <p className={`symbol-label-text`}>Lunar</p>
                                    </div>
                                    {team.lunar1.memory !== "" ? displayCaptureCard('lunar1', 3) : displayCaptureCard('none', 3)}
                                    {team.lunar2.memory !== "" ? displayCaptureCard('lunar2', 4) : displayCaptureCard('none', 4)}
                                    
                                </div>
                                <div className="capture-lunar-2">
                                    {team.lunar3.memory !== "" ? displayCaptureCard('lunar3', 5) : displayCaptureCard('none', 5)}
                                    {team.lunar4.memory !== "" ? displayCaptureCard('lunar4', 6) : displayCaptureCard('none', 6)}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className="footer">
                <button className={`${team.character !== "" ? `${team.character}-bg-color` : "default-bg-color"} footer-button`}
                    onClick={() => handleOpenLog()}>Change Log</button>
                <button className={`${team.character !== "" ? `${team.character}-bg-color` : "default-bg-color"} footer-button`}
                    onClick={() => window.open("https://www.reddit.com/r/LoveAndDeepspace/comments/1jzn1gh/protocore_rater/", "_blank")}>Help & Feedback</button>
            </div>
            { openLog && 
                <div className={`change-log ${team.character !== "" ? `${team.character}-bg-color` : "default-bg-color"}`}>
                    <ChangeLog/>
                </div>
            }
            { showCoreSelector &&
                <div className="overlay">{displaySelectorModal()}</div>
            }
        </div>
    );
}

export default Viewer;